module.exports = __webpack_public_path__ + "img/type-8.6db8bbef.png";